export default __webpack_public_path__ + "static/media/benefit3.42159c6e.svg";